import React, { useState, useEffect, useRef } from 'react'

function MasterCardRupayForm({ mastRupay }) {

  const {
    callbackUrl,
    binNo,
    txAmount,
    payId,
    var1,
    var2,
  } = mastRupay;

  const [canResend, setCanResend] = useState(false);
  const [timer, setTimer] = useState(30);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const [otp, setOtp] = useState('');
  const otpRef = useRef(null);



  const handleResendOtp = async (event) => {
    document.getElementById('verifyOtpError').innerHTML = '';
    if (canResend) {
      console.log("Resend OTP triggered");
      const url = `/pay/otp/submit?var1=${encodeURIComponent(var1)}&var2=${encodeURIComponent(var2)}`;
      setOtp('');
      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            payId: payId,
            otp: otp,
            gateway: 'mastercard3ds2'
          }),
        });

        const data = await response.json();

        // Process response
        if (data.status) {
          setStatus(data.status);
        } else {
          setStatus(false);
        }
      } catch (err) {
        setError(err.message);
        setStatus(false);
      }


      setTimer(30);
      setCanResend(false);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(''); // Clear previous errors

    // Example function for custom validity check
    const evaluateCustomValidityForOtp = () => {
      const otpInput = otpRef.current;
      const validityState = otpInput.validity;

      if (otp === '' || otp.length < 4 || validityState.valueMissing) {
        otpInput.setCustomValidity('Invalid OTP entered');
        setError('Invalid OTP entered');
        return false;
      } else {
        otpInput.setCustomValidity('');
        setError('');
        return true;
      }
    };

    if (!evaluateCustomValidityForOtp()) {

      setError('Invalid OTP format. Please check your OTP.');
      return;
    }

    // Call your OTP verification function
    verifyOTP((isValid) => {
      setError('');
      if (isValid) {
        const rform = document.getElementById('redirectToNpciForm');
        rform.submit();

      } else {
        setError('Provided OTP is invalid. Please try again.');
      }
    });
  };




  const verifyOTP = (callback) => {
    fetch(`/pay/otp/submit?var1=${encodeURIComponent(var1)}&var2=${encodeURIComponent(var2)}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        payId: payId,
        otp: otp,
        gateway: 'mastercard3ds2',
      }),
    })
      .then(response => response.json())
      .then(data => callback(data.status)) // Call the callback with verification result
      .catch(error => {
        console.error('Error:', error);
        callback(false); // In case of error, consider OTP as invalid
      });
  };



  useEffect(() => {
    let timerId;
    if (!canResend && timer > 0) {
      timerId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }

    return () => clearInterval(timerId);
  }, [timer, canResend]);

  const redirectCancel = () => {
    window.location.href = callbackUrl;
  };

  const [isOtpVisible, setOtpVisible] = useState(false);


  const toggleOtpVisibility = () => {
    setOtpVisible(!isOtpVisible);
  };


  return (
    <div>

      <div id="redirectToNpciAcsSimple" xmlns="http://www.w3.org/1999/html">
        <form
          id="redirectToNpciForm"
          onSubmit={handleSubmit}
          name="	redirectToNpciForm"
          method="POST"
          action={callbackUrl}
        >
          <fieldset id="rupayOTP">
            <div align="left">
              {" "}
              <img
                className="RupayLogo"
                src="data:image/svg+xml;base64,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"
              />{" "}
            </div>
            <div className="npciMessage">
              <label id="infoHeaderId" className="rupayLabel">
                Please enter your One Time Password (OTP) sent to your registered
                Mobile No.{" "}
              </label>
            </div>
            <div>
              <table>
                <tbody>
                  <tr>
                    <td>
                      <label id="cardNoId" className="rupayLabel">
                        Card No{" "}
                      </label>
                    </td>

                    <td>
                      {" : "}
                      XXXX XXXX XXXX {mastRupay.binNo}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <label id="merchant" className="rupayLabel">
                        Merchant{" "}
                      </label>
                    </td>

                    <td>: POLICYBAZAAR INSURANCE </td>
                  </tr>
                  <tr>
                    <td>
                      <label id="amount" className="rupayLabel">
                        Amount{" "}
                      </label>
                    </td>

                    <td>
                      {" : "}  {mastRupay.txAmount}{" "}
                      INR{" "}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <label id="otpId" className="enterOtpLabel">
                        Enter OTP
                      </label>
                    </td>

                    <td>
                      <div>
                        <div className="alignEye"  >
                          {" : "}
                          <input
                            id="otp"
                            name="otp"
                            type={isOtpVisible ? 'text' : 'password'}
                            minLength={4}
                            maxLength={10}
                            required
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            ref={otpRef}
                            style={{ border: '4px solid #ccc', padding: '5px', fontSize: '13px' }}

                          />
                        </div>
                        <div className="eye alignEye" onClick={toggleOtpVisibility} id="toggleOtp" />
                      </div>
                    </td>
                   </tr>
                   <tr>
                   <td colSpan={2}>
                      <span id="verifyOtpError" style={{ color: "red",fontSize:"14px" }} >{error}</span>
                    </td>
                   </tr>
                  <tr id="buttonDiv" className="resendLabel" >
                    <td colSpan={2} style={{width:"100%", textAlign:"center"}}>
                      <button type="submit" form="redirectToNpciForm" value="Submit" style={{ border: '1px solid #3965fb', padding: '5px',background:"#3965fb",color:"#fff",fontSize:"14px",height:"40px",width:"84px",marginRight:"12px" }}>
                        Submit
                      </button>
                      <button type="submit" id="cancel" onClick={redirectCancel} type="button" style={{ border: '1px solid #ccc', padding: '5px',background:"#ccc",color:"#253858",fontSize:"14px",height:"40px",width:"84px",marginLeft:"12px" }}>
                        Cancel
                      </button>
                    </td>

                  </tr>
                   </tbody>
              </table>
              <table>
                  <tr>

                    <td colSpan="2" style={{ display: 'flex', justifyContent: 'flex-start', padding: '10px' }}>
                      <button
                        type="submit"
                        onClick={handleResendOtp}
                        id="resendOtpHref"
                        className="resendOtpHrefClass"
                        disabled={!canResend}
                      >
                        Resend OTP
                      </button>


                      &nbsp;
                      <span id="countdowntimer" style={{ fontSize: 14 }}>
                        {canResend ? '' : `Wait ${timer} seconds`}
                      </span> </td>
                  </tr>

              
              </table>
              <input type="hidden" name="payId" id="payId" defaultValue="${payId}" />
              <input
                type="hidden"
                name="secureVar1"
                id="secureVar1"
                defaultValue="${var1}"
              />
              <input
                type="hidden"
                name="secureVar2"
                id="secureVar2"
                defaultValue="${var2}"
              />
            

            </div>
          </fieldset>
        </form>

        <style
          dangerouslySetInnerHTML={{
            __html:
              "        #redirectToNpciAcsSimple{ font-family: Arial, Helvetica, sans-serif; color: #333; text-align: center; } #otp { border-radius: 8px; padding: 5px 33px 5px 12px; width: 100px; font-size: 13px; } #toggleOtp { margin-left: -30px; cursor: pointer; font-size:17px; color:grey; } button { color: #333; font-size: 20px; font-weight: bold; border-radius: 8px; padding: 5px 15px 5px 15px; cursor: pointer; } td { padding:6px  10px; text-align: left; } fieldset { border: 4px solid; margin: 100px auto 110px; background-color: white;width:670px; } table,th,td { margin-left: auto; margin-right: auto; font-size: 20px; } input[type=password]::-ms-reveal, input[type=password]::-ms-clear { display: none; } .npciMessage { font-size: 14px; text-align: center; margin: 0px 50px 0px 50px; } .npciwarningMessage { font-size: 14px; text-align: center; margin: 20px 50px 20px 50px; } .RupayLogo { width: 200px; height: 100px; } .resendOtpHrefClass { background: none !important; border: none; padding: 0 !important; color: #069; text-decoration: underline; cursor: pointer; font-size: 15px; } .resendOtpHrefNewClass { background: none !important; border: none; padding: 0 !important; color: #808080; text-decoration: none; cursor: default; font-size: 15px; } .eye { width: 10px; height: 10px; border: 2px solid grey; border-radius: 75% 15%; position: relative; transform: rotate(45deg); top: 2px; left: 3px; } .eye:before { content: ''; display: block; position: absolute; width: 2px; height: 2px; border: 2px solid grey; border-radius: 50%; left: 3px; top: 2px; } .alignEye { display: inline-block; } @media screen and (max-width: 430px) { .resendOtpHrefClass { font-size: 12px; } button { font-size: 15px; border-radius: 6px; padding: 3px 9px 3px 9px; } td { padding: 7px; } fieldset { border: 1px solid #ccc; margin: 4%;border-radius:4px;width:-webkit-fill-available; } table,th,td { font-size: 15px; } .npciMessage { font-size: 10px; margin: 0px 0px 0px 0px; } .npciwarningMessage { font-size: 10px; margin: 20px 0px 20px 0px; } .RupayLogo { width: 120px; height: 70px; } } @media screen and (max-width: 700px) and (min-width: 600px) { .resendOtpHrefClass { font-size: 12px; } fieldset { border: 2px solid; margin: 5px 20px 20px 5px; } button { font-size: 15px; border-radius: 6px; padding: 3px 9px 3px 9px; } td { padding: 5px; } table,th,td { font-size: 14px; } .npciMessage { font-size: 10px; margin: 0px 20px 0px 20px; } .npciwarningMessage { font-size: 10px; margin: 0px 20px 0px 20px; } .RupayLogo { width: 120px; height: 70px; } } @media screen and (max-width: 860px) and (min-width: 701px) { .resendOtpHrefClass { font-size: 12px; } fieldset { border: 2px solid; margin: 5px 20px 20px 5px; } button { font-size: 15px; border-radius: 6px; padding: 3px 9px 3px 9px; } td { padding: 5px; } table,th,td { font-size: 13px; } .npciMessage { font-size: 8px; margin: 0px 20px 0px 20px; } .npciwarningMessage { font-size: 8px; margin: 0px 20px 0px 20px; } .RupayLogo { width: 120px; height: 70px; } } @media screen and (max-width: 930px) and (min-width: 861px) { .resendOtpHrefClass { font-size: 12px; } fieldset { border: 2px solid; margin: 5px 20px 20px 5px; } button { font-size: 15px; border-radius: 6px; padding: 3px 9px 3px 9px; } td { padding: 5px; } table,th,td { font-size: 14px; } .npciMessage { font-size: 10px; margin: 0px 20px 0px 20px; } .npciwarningMessage { font-size: 10px; margin: 9px 20px 2px 20px; } .RupayLogo { width: 120px; height: 70px; } }    "
          }}
        />
      </div>

    </div>
  );
}
export default MasterCardRupayForm;
